import {createSettingsParams, ISettingsParam, SettingsParamType} from '@wix/tpa-settings';
import {DataType} from '@wix/editor-platform-ooi-metadata-resolver';
import {ISettingsParams} from '../../domain/utils/settings.utils';
import {CartParamNames} from '../../common/constants';

export type ICartPublicData = Partial<{[k in keyof ISettingsParams<typeof settingsParams>]: string | {}}>;

export const settingsParams: Record<string, ISettingsParam> = {
  [CartParamNames.CART_TITLE]: {
    key: CartParamNames.CART_TITLE,
    type: SettingsParamType.String,
    getDefaultValue: ({t}) => t('cart.shopping_cart_title'),
    inheritFromAppScope: true,
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('cart.shopping_cart_title'),
      },
    }),
  },
  [CartParamNames.CART_EMPTY_CART]: {
    key: CartParamNames.CART_EMPTY_CART,
    type: SettingsParamType.String,
    getDefaultValue: ({t}) => t('cart.empty_cart_title'),
    inheritFromAppScope: true,
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('cart.empty_cart_title'),
      },
    }),
  },
  [CartParamNames.CART_CONTINUE_SHOPPING_LINK]: {
    key: CartParamNames.CART_CONTINUE_SHOPPING_LINK,
    type: SettingsParamType.String,
    getDefaultValue: ({t}) => t('cart.continue_shopping'),
    inheritFromAppScope: true,
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('cart.continue_shopping'),
      },
    }),
  },
  [CartParamNames.CART_CONTINUE_SHOPPING_LINK_OBJECT]: {
    key: CartParamNames.CART_CONTINUE_SHOPPING_LINK_OBJECT,
    type: SettingsParamType.Object,
  },
  [CartParamNames.CART_ADD_NOTE_LINK]: {
    key: CartParamNames.CART_ADD_NOTE_LINK,
    type: SettingsParamType.String,
    getDefaultValue: ({t}) => t('cart.buyer_note_add_button_label'),
    inheritFromAppScope: true,
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('cart.buyer_note_add_button_label'),
      },
    }),
  },
  [CartParamNames.CART_INSTRUCTIONS_TEXT]: {
    key: CartParamNames.CART_INSTRUCTIONS_TEXT,
    type: SettingsParamType.String,
    getDefaultValue: ({t}) => t('cart.buyer_note_placeholder'),
    inheritFromAppScope: true,
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('cart.buyer_note_placeholder'),
      },
    }),
  },
  [CartParamNames.CART_ADD_PROMO_CODE_LINK]: {
    key: CartParamNames.CART_ADD_PROMO_CODE_LINK,
    type: SettingsParamType.String,
    getDefaultValue: ({t}) => t('cart.coupon_add_button_label'),
    inheritFromAppScope: true,
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('cart.coupon_add_button_label'),
      },
    }),
  },
  [CartParamNames.CART_BUTTON_TEXT]: {
    key: CartParamNames.CART_BUTTON_TEXT,
    type: SettingsParamType.String,
    getDefaultValue: ({t}) => t('cart.secure_checkout'),
    inheritFromAppScope: true,
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('cart.secure_checkout'),
      },
    }),
  },
  [CartParamNames.CART_V2_DISCLAIMER]: {
    key: CartParamNames.CART_V2_DISCLAIMER,
    type: SettingsParamType.String,
    getDefaultValue: (): null => null,
    inheritFromAppScope: true,
    metadata: () => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: null,
      },
    }),
  },
};

export default createSettingsParams<ISettingsParams<typeof settingsParams>>(settingsParams);
